export default "__VITE_ASSET__Bkh9qMq5__"